import { Button } from '@/components/common/button';

import styles from './field-panel-actions.module.scss';

export type FieldPanelActionsProps = {
  /** The Grower asked to delete this Field. **Nothing is destroyed yet** — the confirmation, the
   *  request and every consequence belong to the caller, which is what keeps this component
   *  presentational and keeps the delete out of `<FieldDetailsPanel>`. */
  onDelete: () => void;
  /**
   * Figma `787:678799` draws a second, equal half — **Edit Field** — and grilling decision 4 puts it
   * in the feature. It is **not** wired in ticket 10: no AC here asks for it and 113584 §11f's edit
   * flow has no destination yet, so shipping a button to nowhere would be worse than shipping none.
   * Pass this and the row becomes the two halves the design draws.
   */
  onEdit?: () => void;
};

/**
 * The Field details panel's actions row (Figma `787:678799`), fed to `<FieldDetailsPanel actions>`.
 *
 * Both buttons are the shipped `<Button>` at its Figma-matching variants: `outline` for Delete (the
 * label colour is the only thing no variant carries) and `neutral` for Edit, which matches exactly.
 */
export function FieldPanelActions({ onDelete, onEdit }: FieldPanelActionsProps) {
  return (
    <>
      <Button
        variant="outline"
        className={[styles.half, styles.delete].join(' ')}
        onClick={onDelete}
      >
        Delete Field
      </Button>
      {onEdit ? (
        <Button variant="neutral" className={styles.half} onClick={onEdit}>
          Edit Field
        </Button>
      ) : null}
    </>
  );
}
